// Copyright (c) 2016 Deere & Company

import {
    resetRegistrationReviewFacets,
    updateRegistrationResults
} from './registration';
import {
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateFacetsDeliveryDateRange,
    updateFacetsRegistrationDateRange
} from './facets';
import {deleteRegistration} from './delete-registration';
import {exportToExcel} from './export-to-excel';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {highRentalDaysExportToExcel} from '../../shared/action-creators/high-rental-days-export-to-excel.js';
import {readMachineStatusUpdates} from '../../machine-status-update/action-creators/get-machine-status-updates';
import sharedActionCreators from '../../shared/action-creators';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {updateFactoryDuplicatePinPlateResults} from '../../factory-users-duplicate-pin-plate/action-creators/factory-duplicate-pin-plates.js';
import {updateTransferResultsWithFacets} from '../../transfers/action-creators/facet-updates';

export default {
    ...exportToExcelActions,
    ...sharedActionCreators,
    deleteRegistration,
    exportToExcel,
    highRentalDaysExportToExcel,
    readMachineStatusUpdates,
    resetRegistrationReviewFacets,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    toggleReportsAccordion,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateFacetsDeliveryDateRange,
    updateFacetsRegistrationDateRange,
    updateFactoryDuplicatePinPlateResults,
    updateRegistrationResults,
    updateTransferResultsWithFacets
};



// WEBPACK FOOTER //
// ./src/product/registration-review/action-creators/index.js